export const Bio = {
  name: "Ranjith Kumar",
  roles: [
    "Full Stack Developer",
    "Mobile App Developer",
    "SaaS Product Developer",
  ],

  description:
    "I'm a Full-Stack Developer and Flutter developer based in Chennai, India, with 2+ years of hands-on experience shipping SaaS platforms and production-grade web & mobile apps. As a React.js and Flutter developer in India, I specialize in Node.js, API design, Docker, and cloud deployment — turning ideas into real products used by real people.",
  github: "https://github.com/Ranjithkumar7200",
  resume:
    "https://drive.google.com/file/d/1y3XM337vMQeMX9fr_5nC_8M0OcZ93lJ3/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/ranjithkumar7200/",
  twitter: " https://x.com/Ranjithkumar0_0?t=rb9mv0E7rYcrq8VEQbgZRg&s=08",
  insta: "https://www.instagram.com/ranjith.jsx?igsh=ZnhzdWo1cjU3cDJh",
  facebook: "https://www.facebook.com/share/16knJRKXMJ/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },

      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },

      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "Google Cloud",
        image:
          "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },

      {
        name: "Nginx",
        image: "https://download.logo.wine/logo/Nginx/Nginx-Logo.wine.png",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/WhatsApp%20Image%202025-05-28%20at%205.00.57%20PM.jpeg?raw=true",
    role: "Software Developer",
    company: "Ideal Corporate Services",
    date: "Oct 2024 - Present",
    desc: "Currently working as Software Developer, contributing to the design, development, and optimization of web applications. Experienced in using JavaScript, React JS, Redux, and Bootstrap to build responsive and interactive user interfaces. Skilled in Flutter for cross-platform mobile development, along with backend experience in Node.js. Successfully integrated REST APIs to ensure seamless data flow between front-end and backend systems.",
    skills: [
      "ReactJS",
      "Redux",
      "JavaScript",
      "Bootstrap",
      "Flutter",
      "Node.js",
      "REST APIs",
      "Mobile Development",
    ],
    doc: "",
  },
  {
    id: 1,
    img: "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/driftmark_technology_logo.jpeg?raw=true",
    role: "Front End Developer",
    company: "Driftmark Technology",
    date: "Oct 2023 - Oct 2024",
    desc: "Responsible for creating websites, web applications, and mobile applications. Designed and developed user interfaces using HTML, CSS, JavaScript, and React ensuring that applications run smoothly across multiple platforms. Built HRMS (Human Resource Management System) with modules for employee management, payroll processing, leave management, and performance evaluation.",
    skills: [
      "ReactJS",
      "Redux",
      "HTML",
      "CSS",
      "JavaScript",
      "Bootstrap",
      "RTK Query",
      "Java",
      "Mobile Applications",
    ],
    doc: "",
  },
  {
    id: 2,
    img: "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/1709284899643.jpeg?raw=true",
    role: "Software Developer Intern",
    company: "Ablest Technologies",
    date: "May 2023 - Oct 2023",
    desc: "Completed 3+ months internship as Full stack developer specializing in Java, Spring MVC, and Spring Boot. Developed web interfaces using HTML5, CSS, Bootstrap, JavaScript and ReactJs. Created robust client-side models and validation systems using modern web technologies.",
    skills: [
      "Java",
      "Spring MVC",
      "Spring Boot",
      "ReactJS",
      "HTML5",
      "CSS",
      "Bootstrap",
      "JavaScript",
      "Full Stack Development",
    ],
    doc: "",
  },
];

export const education = [
  {
    id: 0,
    img: "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/download%20(1).jpeg?raw=true",
    school:
      "P.T.Lee Chengalvaraya Naicker College of Engineering & Technology, Kancheepuram ",
    date: "Sep 2018 - Oct 2022",
    grade: "7.8 CGPA",
    desc: "I have completed my Bachelor's degree in Mechanical Engineering at P.T. Lee Chengalvaraya Naicker College of Engineering & Technology, Kancheepuram, with a CGPA of 7.8",
    degree: "Bachelor of Engineering - Mechanical Engineering",
  },
  {
    id: 1,
    img: "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/TamilNadu_Logo.svg.png?raw=true",
    school: "GOVT HSS, K G Kandigai",
    date: "Apr 2017 - Apr 2018",
    grade: "67.2%",
    desc: "I completed my class 12 high school education at GOVT HSS, K G Kandigai, where I studied Science with Biology Science.",
    degree: "HSC(XII), Science with Biology",
  },
  {
    id: 2,
    img: "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/favicon.png?raw=true",
    school: "St. Charles Higher Secondary School, K.G. Kandigai",
    date: "Apr 2015 - Apr 2016",
    grade: "80.3%",
    desc: "I completed my class 10 education at St. Charles Higher Secondary School, K.G. Kandigai.",
    degree: "SSLC(X)",
  },
];

export const projects = [
  {
    id: 0,
    title: "Chatfuse – SaaS WhatsApp Automation",
    date: "2025",
    duration: "90 Days",
    description:
      "Chatfuse is a SaaS platform for automated WhatsApp marketing and customer engagement. Users can send bulk messages, schedule campaigns, and manage contacts efficiently. The platform includes analytics dashboards and server deployment on BigRock VPS for production-grade scalability.",
    image:
      "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/chatfuse_preview.png?raw=true",
    tags: [
      "React.js",
      "Node.js",
      "MongoDB",
      "SaaS",
      "WhatsApp API",
      "Admin Panel",
      "VPS",
    ],
    category: "web app",
    github: "https://github.com/Ranjithkumar7200",
    webapp: "https://chatfuse.in",
    features: [
      "Bulk WhatsApp messaging with scheduling",
      "Contact management and segmentation",
      "Analytics dashboards for campaign insights",
      "Server deployment with scalability on BigRock VPS",
      "Secure login and role-based access control",
    ],
  },
  {
    id: 1,
    title: "Near Sales – Android Play Store App",
    date: "2025",
    duration: "50 Days",
    description:
      "Near Sales is a fast delivery & local shop discovery app for Android users. Includes product catalog, order management, and secure payments. Features optimized UI/UX for quick browsing and order placement, published on Play Store.",
    image:
      "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/nearsales_preview.png?raw=true",
    tags: ["Flutter", "Node.js", "MongoDB", "Mobile App", "Android"],
    category: "mobile app",
    github: "https://github.com/Ranjithkumar7200",
    webapp:
      "https://play.google.com/store/apps/details?id=com.nearsales.app&pcampaignid=web_share",
    features: [
      "Product catalog with categories and filters",
      "Fast checkout and secure payment integration",
      "Order tracking and notifications",
      "Optimized Android UI for speed and usability",
      "Support for multiple local shops",
    ],
  },
  // {
  //   id: 2,
  //   title: "BDS Cabs – Taxi Booking App & Admin Panel",
  //   date: "2025",
  //   duration: "75 Days",
  //   description:
  //     "BDS Cabs is an Android taxi booking application with a comprehensive admin panel. The platform allows users to book cabs, track rides, and make secure payments. Admin panel supports driver management, bookings overview, and reporting. Complete end-to-end development, deployment, and server management done by me on BigRock VPS.",
  //   image:
  //     "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/bds_preview.webp?raw=true",
  //   tags: [
  //     "Flutter",
  //     "Node.js",
  //     "MongoDB",
  //     "Android App",
  //     "Admin Panel",
  //     "VPS",
  //   ],
  //   category: "mobile app",
  //   github: "https://github.com/Ranjithkumar7200/bdscabs",
  //   webapp:
  //     "https://play.google.com/store/apps/details?id=com.bdscabs.app&hl=en",
  //   features: [
  //     "Android app for users with cab booking, tracking, and payments",
  //     "Admin panel for managing drivers, rides, and reporting",
  //     "End-to-end development with Flutter, Node.js, MongoDB",
  //     "Server deployment and hosting on BigRock VPS",
  //     "Secure login and role-based access for drivers & admins",
  //   ],
  // },
  {
    id: 3,
    title: "Mahalaxmi Diagnostics",
    date: "2024",
    duration: "121 Days",
    description:
      "Mahalaxmi Diagnostics Center (MMS) is a digital platform for managing diagnostics appointments, patient registrations, and test report delivery. The system supports online test booking, report uploads, and secure login for patients and administrators, hosted on BigRock VPS to ensure reliability.",
    image:
      "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/WhatsApp%20Image%202025-05-29%20at%2011.50.25%20AM.jpeg?raw=true",
    tags: [
      "React Js",
      "React Bootstrap",
      "Redux Toolkit",
      "JWT",
      "jsPDF",
      "REST APIs",
      "Node JS",
      "Express JS",
      "Mongo DB",
      "VPS",
    ],
    category: "web app",
    github: "https://github.com/Ranjithkumar7200",
    webapp: "https://mahalakshmidiagnostics.com/",
    features: [
      "Dynamic and responsive UI using React.js and React Bootstrap",
      "Integrated REST APIs using Redux Toolkit for booking and user management",
      "Authentication and role-based access using JWT",
      "Admin dashboard to manage patients, test bookings, and report uploads",
      "Cloudinary for report uploads and jsPDF for downloadable reports",
      "Server deployed and maintained on VPS",
    ],
  },
  {
    id: 4,
    title: "PMK Scan – Healthcare Admin Panel",
    date: "2024",
    duration: "60 Days",
    description:
      "PMK Scan is an admin platform for healthcare management including patient tracking, staff management, and report generation. Features role-based access control (RBAC), real-time notifications, and smooth integration with hospital workflows, hosted on BigRock VPS.",
    image:
      "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/pmk_preview.png?raw=true",
    tags: [
      "React.js",
      "Node.js",
      "MongoDB",
      "Admin Panel",
      "Healthcare",
      "RBAC",
      "VPS",
    ],
    category: "web app",
    github: "https://github.com/Ranjithkumar7200/pmk-scan",
    webapp: "https://pmkscan.com",
    features: [
      "Patient management and staff tracking",
      "Role-based access control (RBAC)",
      "Real-time notifications for reports and updates",
      "Dashboard for monitoring hospital workflow",
      "Hosted and maintained on VPS",
    ],
  },
  {
    id: 5,
    title: "Trackio – Smart Expense Tracker",
    date: "2024",
    description:
      "Trackio is a personal finance management mobile application that helps users efficiently track expenses, set budgets, and analyze spending behavior. Designed with a clean and intuitive UI, the app leverages smart features like AI-assisted insights, real-time budgeting, and notification reminders. Published on Google Play Store.",
    image:
      "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/WhatsApp%20Image%202025-05-29%20at%2010.48.50%20AM.jpeg?raw=true", // Replace with actual app screenshot
    tags: [
      "Flutter",
      "AI Integration",
      "Mobile Development",
      "Push Notifications",
    ],
    category: "mobile app",
    github: "https://github.com/Ranjithkumar7200", // Add your GitHub link
    webapp:
      "https://play.google.com/store/apps/details?id=com.trackio.app&pcampaignid=web_share", // Add Play Store link
    duration: "59 Days",
    features: [
      "Smart Expense Tracking with category suggestions",
      "Budget setting and real-time monitoring",
      "AI Chat Assistant for financial insights",
      "Secure local data storage",
      "Push notifications for payment reminders",
      "Category management with icon support",
    ],
  },
  //   {
  //   id: 2,
  //   title: "Clipdart – Social Media Video Downloader",
  //   date: "2025",
  //   duration: "41 Days",
  //   description:
  //     "Clipdart is a lightweight and high-speed web app that allows users to download Instagram Reels, YouTube Shorts, YouTube Videos, Instagram Posts, and Stories with a single click. Designed for simplicity and speed, Clipdart offers a seamless, ad-free experience with mobile-friendly UI and fast processing via backend APIs.",
  //   image:
  //     "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/clipdart_preview.png?raw=true",
  //   tags: [
  //     "React.js",
  //     "Node.js",
  //     "REST API",
  //     "Video Downloader",
  //     "SEO Optimized",
  //     "Responsive Design",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/Ranjithkumar7200/clipdart",
  //   webapp: "https://clipdart.xyz",
  //   features: [
  //     "Download Instagram Reels in HD",
  //     "Support for YouTube Shorts and Videos",
  //     "Instagram Stories & Post Downloader",
  //     "Responsive, mobile-friendly UI",
  //     "SEO Optimized with meta, Open Graph & FAQ schema",
  //     "Integrated backend API for fast media processing",
  //     "Custom domain & deployed on Vercel",
  //   ],
  // },
  // {
  //   id: 3,
  //   title: "Face Attendance System",
  //   date: "2024",
  //   description:
  //     "The Face Attendance System is a contactless solution using face-api.js for secure and efficient attendance tracking. It employs advanced browser-based facial recognition to identify individuals, log attendance with timestamps, and generate detailed reports.",
  //   image:
  //     "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/What-Is-a-Facial-Recognition-Attendance-System-1024x576.webp?raw=true", // Replace with actual screenshot
  //   tags: [
  //     "React Js",
  //     "Node Js",
  //     "MongoDB",
  //     "MySQL",
  //     "face-api.js",
  //     "Facial Recognition",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/Ranjithkumar7200",
  //   webapp: "",
  //   duration: "61 Days",
  //   features: [
  //     "Real-time face detection and recognition",
  //     "User registration with secure photo storage",
  //     "Admin dashboard for monitoring and exporting reports",
  //     "Encrypted data storage for robust security",
  //     "Cross-platform accessibility via web and mobile devices",
  //     "Local deployment ensuring functionality without internet dependency",
  //   ],
  // },
  // {
  //   id: 4,
  //   title: "DevUpvers - Developer Community Platform",
  //   date: "2024",
  //   description:
  //     "DevUpvers is a comprehensive developer community platform that connects developers worldwide. It features project showcases, skill-based networking, collaborative tools, and resources for professional growth. The platform serves as a hub for developers to share knowledge, find opportunities, and build meaningful connections in the tech industry.",
  //   image:
  //     "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/WhatsApp%20Image%202025-05-29%20at%2011.52.18%20AM.jpeg?raw=true", // Replace with actual screenshot
  //   tags: [
  //     "React Js",
  //     "React-Bootstrap",
  //     "EdTech",
  //     "Interactive Education",
  //     "Online Learning Platform",
  //     "Community Learning",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/Ranjithkumar7200",
  //   webapp: "https://devupvers.com/",
  //   duration: "180 Days",
  //   features: [
  //     "Interactive online courses with real-time engagement",
  //     "AI-powered adaptive learning experiences",
  //     "Self-paced learning paths for flexible study",
  //     "User-friendly developer and student profiles",
  //     "Community forums and collaborative learning spaces",
  //     "Expert-curated courses and learning content",
  //     "Skill tracking and progress dashboards",
  //     "Mobile-responsive design for learning on the go",
  //     "Event scheduling and virtual tech meetups",
  //     "Secure authentication and user management",
  //   ],
  // },
  // {
  //   id: 5,
  //   title: "Trains On Wheels",
  //   date: "2024",
  //   description:
  //     "Trains On Wheels is a complete solution for all your IRCTC and Metro train needs! Check PNR status, Live train status, and Schedules for local and metro trains across India with regional language support. Features referral system and enhanced user experience.",
  //   image:
  //     "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/WhatsApp%20Image%202025-05-29%20at%2011.35.20%20AM.jpeg?raw=true", // Replace with actual screenshot
  //   tags: ["Flutter", "Firebase", "Node js", "Express js", "Redux", "MongoDB"],
  //   category: "mobile app",
  //   github: "https://github.com/Ranjithkumar7200", // Add your GitHub link
  //   webapp: "", // Add live demo link
  //   duration: "90 Days",
  //   features: [
  //     "PNR status checking",
  //     "Live train status and schedules",
  //     "Regional language support",
  //     "Referral system to earn rewards",
  //     "Speedometer and clean my coach features",
  //     "Support for local and metro trains across India",
  //   ],
  // },
  // {
  //   id: 6,
  //   title: "Refix System",
  //   date: "2024",
  //   description:
  //     "Re-Fix System is an e-commerce platform dedicated to providing comprehensive solutions for laptop rental, repair services, and refurbished products. The platform features a seamless user experience with integrated payment gateways, dynamic cart system, and chatbot support.",
  //   image:
  //     "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/WhatsApp%20Image%202025-05-29%20at%2011.44.20%20AM.jpeg?raw=true", // Replace with actual screenshot
  //   tags: [
  //     "React Js",
  //     "Redux",
  //     "Node Js",
  //     "MongoDB",
  //     "Bootstrap",
  //     "HTML5",
  //     "CSS3",
  //     "JavaScript",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/Ranjithkumar7200", // Add your GitHub link
  //   webapp: "https://refixsystems.vercel.app/", // Add live demo link
  //   duration: "61 Days",
  //   features: [
  //     "Comprehensive laptop rental and repair services",
  //     "Integrated payment gateways",
  //     "Dynamic cart system",
  //     "Chatbot support for customer assistance",
  //     "Robust order management system",
  //     "Admin panel for efficient management",
  //   ],
  // },
  // {
  //   id: 7,
  //   title: "Sports Betting App",
  //   date: "2024",
  //   description:
  //     "The Sports Bet Mobile App merges the excitement of cricket, football, tennis, and more with the social buzz of a media platform. It's where sports enthusiasts come together to share bet posts, predict match outcomes, and celebrate victories.",
  //   image:
  //     "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/original-8cad19f888ebce26da97773411dcf28a.webp?raw=true",
  //   tags: ["Flutter", "Firebase", "Node js", "Express js", "Redux", "MongoDB"],
  //   category: "mobile app",
  //   github: "https://github.com/Ranjithkumar7200", // Add your GitHub link
  //   webapp: "", // Add live demo link
  //   duration: "31 Days",
  //   features: [
  //     "Multi-sport betting (Cricket, Football, Tennis)",
  //     "Social media platform integration",
  //     "Match outcome predictions",
  //     "Community features for sports enthusiasts",
  //     "Real-time updates and notifications",
  //   ],
  // },
  // {
  //   id: 8,
  //   title: "HRMS - Human Resource Management System",
  //   date: "2023-2024",
  //   description:
  //     "The HRMS Admin project is designed to streamline and manage various HR functions for Driftmark Technologies. The system includes modules for employee management, payroll processing, leave management, and performance evaluation.",
  //   image:
  //     "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/smarthr-laravel-preview.avif?raw=true", // Replace with actual screenshot
  //   tags: [
  //     "React",
  //     "Redux",
  //     "RTK Query",
  //     "React-Bootstrap",
  //     "Node Js",
  //     "MongoDB",
  //     "Employee Management",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/Ranjithkumar7200", // Add your GitHub link
  //   webapp: "", // Add live demo link
  //   duration: "123 Days",
  //   features: [
  //     "Employee management and data tracking",
  //     "Payroll processing system",
  //     "Leave management with approval workflows",
  //     "Performance evaluation modules",
  //     "HR analytics and reporting",
  //     "Admin dashboard for HR operations",
  //   ],
  // },
  // {
  //   id: 9,
  //   title: "Nexonify Tech - Digital Solutions Platform",
  //   date: "2023-2024",
  //   description:
  //     "Nexonify Tech is a comprehensive digital solutions platform that transforms online presence through custom web development, mobile app development, and digital strategy services. The platform showcases our expertise in creating responsive, user-friendly websites and engaging mobile applications tailored to business needs.",
  //   image:
  //     "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/WhatsApp%20Image%202025-05-29%20at%2012.37.16%20PM.jpeg?raw=true", // Replace with actual screenshot
  //   tags: [
  //     "HTML",
  //     "CSS",
  //     "Java Script",
  //     "Bootstrap",
  //     "Vercel",
  //     "Responsive Design",
  //     "Web Development",
  //     "Mobile App Development",
  //     "Digital Strategy",
  //     "UI/UX Design",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/Ranjithkumar7200", // Add your GitHub link
  //   webapp: "https://nexonify-tech.vercel.app/", // Add live demo link
  //   duration: "10 Days",
  //   features: [
  //     "Custom web development solutions showcase",
  //     "Mobile app development portfolio",
  //     "Responsive design across all devices",
  //     "Digital strategy services presentation",
  //     "Interactive service showcases (90% Web Dev, 85% Mobile, 92% UI/UX)",
  //     "Client testimonials and feedback system",
  //     "Modern UI/UX with cutting-edge technology",
  //     "Cloud solutions integration",
  //     "Business growth focused approach",
  //     "Web Development - Custom, responsive websites",
  //     "Mobile App Development - iOS and Android apps",
  //     "UI/UX Design - User-centered design approach",
  //     "Cloud Solutions - Scalable business operations",
  //     "Digital Strategy - Data-driven campaigns and insights",
  //   ],
  // },

  // {
  //   id: 10,
  //   title: "My Portfolio Website",
  //   duration: "3 days",
  //   description:
  //     "A portfolio website that exemplifies beliefs, skills, qualifications, education, training, and experiences. It provides insight into personality and work ethic with a modern, responsive design.",
  //   image:
  //     "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/WhatsApp%20Image%202025-05-29%20at%2012.43.12%20PM.jpeg?raw=true",
  //   tags: ["HTML5", "CSS3", "ReactJS", "Responsive Design"],
  //   category: "web app",
  //   github: "/",
  //   webapp: "/",
  //   features: [
  //     "Responsive design across all devices",
  //     "Modern UI/UX implementation",
  //     "Skills and experience showcase",
  //     "Project portfolio display",
  //     "Contact and social media integration",
  //   ],
  // },
  // {
  //   id: 11,
  //   title: "Attendance Management System",
  //   date: "2024",
  //   description:
  //     "This is a full-stack website that maintains records of all employees with their personal information. It keeps track of hours worked by an employee on a particular project assigned to him. It maintains time sheets and generates detailed and summary reports.",
  //   image:
  //     "https://github.com/Ranjithkumar7200/portfolio-images/blob/main/download.png?raw=true", // Replace with actual screenshot
  //   tags: ["HTML", "CSS", "React Js", "Node Js", "MongoDB"],
  //   category: "web app",
  //   github: "https://github.com/Ranjithkumar7200",
  //   webapp: "",
  //   duration: "61 Days",
  //   features: [
  //     "Employee records management",
  //     "Project-wise time tracking",
  //     "Automated timesheet generation",
  //     "Detailed and summary reports",
  //     "Admin panel for management",
  //     "Personal information tracking",
  //   ],
  // },
];

export const getExperienceInYears = (startDate) => {
  const start = new Date(startDate);
  const now = new Date();

  const years = now.getFullYear() - start.getFullYear();
  const months = now.getMonth() - start.getMonth();

  const totalMonths = years * 12 + months;
  const experience = (totalMonths / 12).toFixed(1);

  return experience;
};
